import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Team from './components/Team';
import Services from './components/Services';
import Testimonials from './components/Testimonials';
import BlogList from './components/BlogList';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

function App() {
  return (
    <div className="App">
    <Navbar />
    <main>
      <Hero />
      <About />
      <Team />
      <Services />
      <Testimonials />
      <BlogList />
      <Contact />
    </main>
    <Footer />
    <WhatsAppButton />
  </div>    
  );
}

export default App
